<template>
  <div>
    <div
      class="position-absolute cursor-pointer"
      style="z-index: 9999999; right: 20px; top: 20px;"
    >
      <h4>
        <img
          width="30"
          height="30"
          class="cursor-pointer"
          @click="$modal.hide($parent.name)"
          src="https://cdn.howuku.com/images/close-icon.png"
        />
      </h4>
    </div>
    <div class="reminder-container" style="z-index: 99999 !important">
      <div class="row">
        <div class="col-md-12">
          <h5>Verify your email to continue using {{ $isMida ? 'Mida' : 'Howuku' }}</h5>
        </div>
      </div>
      <div class="row my-5">
        <div class="col-md-12 justify-content">
          <button class="btn btn-first" @click="resendEmail()" v-if="!isResent">
              <img
                width="30"
                class="mr-2"
                src="../assets/img/email.png"
              />
              Resend Email</button>
          <!-- <button class="btn btn-first" @click="resendEmail()" v-else disabled>
              <img
                width="30"
                class="mr-2"
                src="../assets/img/email.png"
              />
              Resend Email</button> -->
          <div class="alert alert-success w-100" v-if="isResent">Awesome! Please check your email at <b>{{ $session.get('email') }}</b></div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <p class="text-muted">We will send a verification email to your email</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const VueMarkdown = () => import('vue-markdown')

export default {
  components: {
    VueMarkdown,
  },
  data: function () {
    return {
      isResent: false,
    }
  },
  mounted() {},
  methods: {
    resendEmail() {
      this.$http.get(`${process.env.API_ENDPOINT}/sendVerificationEmail/${this.$session.get('email')}/${this.$session.get('user_id')}/${this.$session.get('name')}/${this.$isOptimize}`, {
      }).then(() => {
        this.isResent = true

        // hide the modal after 3 seconds
        setTimeout(() => {
          this.$modal.hide('email_reminder')
        }, 6000)
      })
    },
  },
}
</script>

<style scoped>
.reminder-container {
  padding: 60px 60px 60px 30px;
  text-align: center;
}

/* .reminder-container p {
  font-size: 18px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
} */
.reminder-container button img {
  margin-top: -3px;
}

.reminder-container button {
  font-size: 20px;
  padding: 15px 50px;
}

.reminder-container .alert {
  width: 200px;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/EmailReminder.vue